const isNonEmptyString = (v) => typeof v === "string" && v.trim() !== "";

const normalizeAngle = (deg) => ((deg % 360) + 360) % 360;

const angularDistance = (a, b) => {
  const d = Math.abs(normalizeAngle(a) - normalizeAngle(b));
  return d > 180 ? 360 - d : d;
};

function normalizeDirectionalSet(list) {
  if (!Array.isArray(list)) return [];
  return list
    .filter(
      (item) =>
        item &&
        isNonEmptyString(item.url) &&
        typeof item.angle === "number" &&
        isFinite(item.angle)
    )
    .map((item) => ({ angle: normalizeAngle(item.angle), url: item.url }))
    .sort((a, b) => a.angle - b.angle);
}

export function normalizeCustomIcons(raw) {
  const src = raw && typeof raw === "object" ? raw : {};
  return {
    pickup: isNonEmptyString(src.pickup) ? src.pickup : null,
    checkmark: isNonEmptyString(src.checkmark) ? src.checkmark : null,
    customer: isNonEmptyString(src.customer) ? src.customer : null,
    bike: normalizeDirectionalSet(src.bike),
    car: normalizeDirectionalSet(src.car),
  };
}

export function pickDirectionalIcon(set, heading) {
  if (!Array.isArray(set) || set.length === 0) return null;
  const h = normalizeAngle(typeof heading === "number" ? heading : 0);

  if (set.length === 1) {
    return { url: set[0].url, rotation: normalizeAngle(h - set[0].angle) };
  }

  let best = set[0];
  let bestDist = angularDistance(h, best.angle);
  for (let i = 1; i < set.length; i++) {
    const dist = angularDistance(h, set[i].angle);
    if (dist < bestDist) {
      best = set[i];
      bestDist = dist;
    }
  }
  // Multi-icon sets are pre-drawn per direction, so pick the nearest one and
  // don't rotate it. Accuracy depends on how many directions the brand uploads
  // (8 icons => at most 22.5 deg off).
  return { url: best.url, rotation: 0 };
}

/** Warm the browser cache so direction swaps don't flicker while loading. */
export function preloadCustomIcons(icons) {
  if (typeof Image === "undefined" || !icons) return;
  const urls = [
    icons.pickup,
    icons.checkmark,
    icons.customer,
    ...(icons.bike || []).map((i) => i.url),
    ...(icons.car || []).map((i) => i.url),
  ].filter(Boolean);
  urls.forEach((url) => {
    const img = new Image();
    if (process.env.NODE_ENV !== "production") {
      img.onerror = () => console.warn("Failed to preload custom tracking icon:", url);
    }
    img.src = url;
  });
}
